
  <div class="circles" style="will-change: transform;">
    <div class="circle top-right"></div>
    <div class="circle bottom-center"></div>
    <div class="circle left-small"></div>
  </div>